export const articles = [
  {
    id: 'plot-001',
    title: '《疯狂试爱2》主要角色关系全解析：心动与试探的多重博弈',
    type: 'plot',
    category: 'plot',
    subcategory: '主要角色',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20silhouetted%20lovers%20facing%20each%20other%20under%20a%20single%20warm%20streetlight%2C%20deep%20navy%20blue%20night%20background%2C%20romantic%20tension%2C%20moody%20atmospheric%20lighting%2C%20poster%20style%20composition%20with%20dark%20simple%20background%20and%20central%20focus%2C%20high%20detail%2C%2035mm%20look&width=800&height=450&seq=fsa2-c01&orientation=landscape',
    date: '2026-09-28',
    summary:
      '从男女主角的初次相遇，到配角之间的情感拉扯，《疯狂试爱2》用细腻的关系网撑起了整部作品的张力。本文以角色为线索，逐一拆解人物之间的心动与试探。',
    views: 18620,
    tags: ['角色关系', '人物解析', '情感线'],
    cast: ['林知夏', '沈砚舟', '苏晚', '周予安'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '《疯狂试爱2》延续前作对都市情感的关注，讲述一群在快节奏城市中寻找真心的年轻人，如何在试探与坦白之间重新学习爱与被爱的故事。',
    fullText:
      '在《疯狂试爱2》中，角色关系从来不是一条直线，而是一张被反复折叠又重新展开的网。男女主角的相遇带着明显的偶然性，正是这份偶然让两人的靠近显得格外真实。\n\n首先是男女主角之间的主线关系。两人在价值观与生活节奏上高度相似，却在表达方式上截然相反，一方习惯把情绪藏进细节，另一方则倾向于直白地要求答案。这种错位构成了全剧最主要的情感张力，也让每一次和解都显得来之不易。\n\n其次是配角之间的支线关系。剧中并没有把配角简单处理成推动主线的工具，而是赋予他们独立的情感动机。尤其是苏晚与周予安之间的拉扯，几乎复刻了成年人感情里那种“明明在意却不肯先低头”的常见困境。\n\n最后值得关注的是角色群像之间的互相映照。每个人物的选择都在悄悄回答同一个问题：在一段关系里，究竟是坚持自我更重要，还是为对方改变更重要？《疯狂试爱2》没有给出标准答案，而是把这个问题留在观众心里。',
  },
  {
    id: 'plot-002',
    title: '《疯狂试爱2》剧情线索梳理：从初次相遇看情感走向',
    type: 'plot',
    category: 'plot',
    subcategory: '剧情线索',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20city%20street%20at%20night%20with%20warm%20street%20lamps%20and%20deep%20blue%20shadows%2C%20lone%20walking%20figure%20in%20the%20distance%2C%20romantic%20urban%20melancholy%2C%20moody%20atmospheric%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail%2C%2035mm%20cinematic%20look&width=800&height=450&seq=fsa2-c02&orientation=landscape',
    date: '2026-09-25',
    summary:
      '一条完整的剧情线，往往藏在被忽略的细节里。本文按时间顺序梳理《疯狂试爱2》的关键情节点，还原故事从相遇走向抉择的完整轨迹。',
    views: 15240,
    tags: ['剧情线索', '时间线', '情节梳理'],
    cast: ['林知夏', '沈砚舟', '苏晚'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '故事以一次看似普通的误会开场，随着两位主角不断接近，隐藏在平静生活下的旧日心结被逐渐揭开。',
    fullText:
      '如果只看表面，《疯狂试爱2》讲的是一段都市爱情；但顺着线索往下看，它其实讲的是一次自我和解。\n\n第一条线索来自开场的那场雨。男女主角在便利店门口共撑一把伞，这个看似随意的桥段，其实是全剧情感基调的预告——两个人都习惯把善意藏在行动里，而不是语言里。\n\n第二条线索贯穿中段。剧中多次出现“未寄出的消息”这一意象，它既是两人沟通受阻的象征，也暗示了他们都曾在过去的关系里受过伤，因此格外谨慎。\n\n第三条线索集中在结尾前的高潮。当误会终于被摊开，两人并没有立刻拥抱和好，而是先各自沉默了很久。这段留白恰恰是全剧最诚实的部分：真正的和解，从来需要先面对自己。\n\n把这些线索串起来你会发现，《疯狂试爱2》的节奏并不急，它愿意花时间去铺陈情绪，也正因如此，最后的释怀才显得足够有分量。',
  },
  {
    id: 'plot-003',
    title: '《疯狂试爱2》结局深度解析：那些被忽略的温柔伏笔',
    type: 'plot',
    category: 'plot',
    subcategory: '结局解析',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20sunrise%20over%20a%20quiet%20city%20skyline%2C%20warm%20orange%20light%20blending%20into%20deep%20blue%20morning%20sky%2C%20hopeful%20romantic%20mood%2C%20soft%20atmospheric%20haze%2C%20dark%20simple%20background%20with%20negative%20space%20for%20text%2C%20high%20detail%2C%2035mm%20cinematic%20look&width=800&height=450&seq=fsa2-c03&orientation=landscape',
    date: '2026-09-22',
    summary:
      '结局留下的并非答案，而是一个更温柔的问题。本文带你重看结尾的几个关键镜头，找出那些被情绪淹没的伏笔。',
    views: 21380,
    tags: ['结局解析', '伏笔', '深度解读'],
    cast: ['林知夏', '沈砚舟', '周予安'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '在经历误解与分离之后，两位主角最终选择以更成熟的方式面对彼此，也为观众留下关于“关系如何继续”的开放式思考。',
    fullText:
      '《疯狂试爱2》的结局很容易被误读成“大团圆”，但如果细看镜头语言，会发现导演留下了更克制、也更真实的态度。\n\n第一个伏笔是结尾的天气。全剧大量场景都在雨夜与阴天，而最后一幕却出现了久违的晴光。这不是简单的情绪回暖，而是在暗示：他们的关系终于走出了那个反复循环的困局。\n\n第二个伏笔是那件被重新穿上的旧外套。它在前文出现过两次，每次都伴随一次错过。结尾再次出现，意味着主角终于愿意主动去弥补，而不是等待对方先开口。\n\n第三个伏笔藏在最后一句对白里。那句听上去轻描淡写的“我们慢慢来”，其实是对全剧“疯狂试爱”这一主题的反转——真正的爱不是疯狂试探，而是允许彼此慢慢靠近。\n\n所以《疯狂试爱2》的结局不是终点，而是一种态度的确立。它把选择权交还给角色，也交还给每一个正在经历类似困境的观众。',
  },
  {
    id: 'news-001',
    title: '《疯狂试爱2》正式官宣定档，全新预告片同步曝光',
    type: 'news',
    category: 'news',
    subcategory: '官方发布',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20crowded%20premiere%20red%20carpet%20at%20night%20with%20deep%20blue%20ambient%20light%20and%20warm%20orange%20spotlights%2C%20glamorous%20event%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail%2C%2035mm%20look&width=800&height=450&seq=fsa2-c04&orientation=landscape',
    date: '2026-10-08',
    summary:
      '官方于今日正式宣布《疯狂试爱2》定档，并同步释出全新预告片。预告片以一段未完成的对话开场，迅速点燃了影迷的讨论热情。',
    views: 42860,
    tags: ['定档', '预告片', '官方发布'],
    cast: ['林知夏', '沈砚舟'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '官方发布的定档预告以极简对白与强烈视觉对比为特色，暗示作品将延续前作细腻的情感刻画风格。',
    fullText:
      '今日，《疯狂试爱2》官方正式公布定档信息，并同步上线全新预告片。短短两分钟的预告，没有交代太多剧情，却用一组组情绪张力十足的镜头吊足了胃口。\n\n预告片以一段未完成的对话开场，男女主角隔着半开的门对视，谁都没有先开口。这段被刻意掐断的对白，成为整支预告片最具讨论度的画面。\n\n随后的镜头快速切换，雨夜、天桥、空荡的办公室轮番出现，配乐从安静逐渐转向明亮，恰好呼应了作品“从试探走向坦白”的情感主线。\n\n据官方透露，本支预告片中的画面大多来自作品前半段的真实内容，并未做过多修饰，这也让观众对成片的完成度更有信心。',
  },
  {
    id: 'news-002',
    title: '《疯狂试爱2》主创团队亮相发布会，分享创作幕后',
    type: 'news',
    category: 'news',
    subcategory: '最新动态',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20panel%20discussion%20stage%20with%20warm%20orange%20stage%20lighting%20against%20deep%20blue%20backdrop%2C%20blurred%20speakers%20and%20microphones%2C%20press%20conference%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c05&orientation=landscape',
    date: '2026-10-05',
    summary:
      '在昨日举行的发布会上，《疯狂试爱2》导演与主演团队悉数到场，围绕创作初衷、角色塑造与拍摄细节展开分享。',
    views: 26490,
    tags: ['发布会', '主创', '幕后'],
    cast: ['林知夏', '沈砚舟', '苏晚', '周予安'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '发布会现场，主创团队分享了作品在剧本打磨与表演方式上的诸多考究，也回应了影迷最关心的问题。',
    fullText:
      '在昨日的发布会上，《疯狂试爱2》主创团队首次集体亮相，现场气氛热烈。导演表示，这一次的创作更希望把镜头对准“关系里的沉默”，而不是激烈的冲突。\n\n谈及角色塑造，主演分享了为贴近人物所做的准备，包括提前一个月进入角色生活节奏、反复揣摩台词潜台词等，力求让每一次情绪转折都显得自然可信。\n\n被问到是否会考虑拍摄续作时，主创团队给出了开放的回答：先把眼前这个故事讲好，未来一切皆有可能。\n\n发布会尾声还播放了一段未经公开的片段，画面简洁却情感饱满，赢得现场一片掌声。',
  },
  {
    id: 'news-003',
    title: '都市爱情题材持续回暖，《疯狂试爱2》为何备受期待',
    type: 'news',
    category: 'news',
    subcategory: '行业观察',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20abstract%20modern%20city%20skyline%20at%20dusk%20with%20deep%20blue%20tones%20and%20warm%20orange%20window%20lights%2C%20minimal%20geometric%20buildings%2C%20urban%20romance%20mood%2C%20moody%20atmospheric%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c06&orientation=landscape',
    date: '2026-10-02',
    summary:
      '近年来都市情感题材不断回暖，而《疯狂试爱2》凭借扎实的剧本与克制的情感表达，被认为是这一波回暖中的代表性作品。',
    views: 17830,
    tags: ['行业观察', '都市情感', '趋势'],
    cast: ['林知夏', '沈砚舟'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '从题材选择到叙事节奏，《疯狂试爱2》贴合了当下观众对真实情感的期待，也因此获得了较高的讨论度。',
    fullText:
      '过去几年，观众对都市情感题材的耐心一度被消耗，原因在于套路化的表达和悬浮的情节。而《疯狂试爱2》的出现，让这一题材重新被认真对待。\n\n它最明显的变化在于节奏。作品愿意用大量篇幅描写日常细节，而不是急于制造戏剧冲突，这让情感转变有了可信的落点。\n\n其次是人物的真实性。剧中的主角并不完美，会犹豫、会逃避、会说错话，这种不完美反而拉近了与观众的距离。\n\n从行业角度看，《疯狂试爱2》的受期待，也说明市场正在重新奖励那些愿意沉下心讲故事的创作者。',
  },
  {
    id: 'news-004',
    title: '《疯狂试爱2》主题曲正式上线，旋律引发观众共鸣',
    type: 'news',
    category: 'news',
    subcategory: '最新动态',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20vintage%20headphones%20and%20a%20microphone%20on%20a%20dark%20table%20with%20warm%20orange%20rim%20light%20and%20deep%20blue%20shadows%2C%20music%20studio%20mood%2C%20moody%20atmospheric%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c07&orientation=landscape',
    date: '2026-09-29',
    summary:
      '《疯狂试爱2》主题曲于今日正式上线，歌曲以克制的编曲与真挚的歌词，精准贴合了作品的情感基调。',
    views: 33920,
    tags: ['主题曲', '音乐', '最新动态'],
    cast: ['林知夏', '沈砚舟'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '主题曲以钢琴为主线索，配合温暖的弦乐编排，呼应了作品中关于“慢慢靠近”的情感表达。',
    fullText:
      '《疯狂试爱2》主题曲今日正式上线，一经发布便在多个平台引发讨论。与许多强调煽情的影视歌曲不同，这首歌选择了克制而内敛的表达方式。\n\n编曲上，钢琴是绝对的主角，弦乐的加入非常节制，只在情绪最需要推高的段落出现，留给听众足够的呼吸空间。\n\n歌词则延续了作品一贯的细腻，把“说不出口的在意”写成了具象的画面，也因此被不少听众评价为“唱出了成年人的心事”。\n\n据悉，主题曲将在作品中多次以不同编曲形式出现，用来对应角色情绪的变化。',
  },
  {
    id: 'feature-001',
    title: '《疯狂试爱2》幕后花絮：一场戏反复打磨三十次的执着',
    type: 'feature',
    category: 'feature',
    subcategory: '幕后花絮',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20film%20set%20with%20camera%20equipment%20and%20warm%20orange%20work%20lights%20against%20deep%20blue%20evening%20sky%2C%20crew%20silhouettes%20behind%20the%20scenes%2C%20moody%20atmospheric%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c08&orientation=landscape',
    date: '2026-09-20',
    summary:
      '为了一场情绪转折戏，主创团队反复打磨了三十余次。花絮镜头记录下了镜头背后那些不被看到的坚持。',
    views: 14260,
    tags: ['幕后花絮', '拍摄现场', '敬业'],
    cast: ['林知夏', '沈砚舟'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '花絮聚焦作品中最具挑战性的一场戏，展现了演员与导演在情绪表达上的反复磨合过程。',
    fullText:
      '在《疯狂试爱2》的拍摄现场，有一场戏被主创团队反复拍摄了三十余次，成为整个拍摄周期中耗时最长的一幕。\n\n这场戏的核心并不复杂，男女主角只需要在一个安静的房间里完成一次对视。但导演希望画面里能同时呈现“克制”与“想说又不敢说”的复杂情绪，这让简单的动作变得格外困难。\n\n演员在每一次拍摄后都会主动和导演讨论细节，从眼神停留的时长到呼吸的节奏，反复调整。现场工作人员回忆，那天的收工时间比原计划晚了近三个小时。\n\n最终的成片里，这场戏只有四十秒，却成为许多观众心中的高光片段。花絮记录下的，正是这四十秒背后不为人知的耐心。',
  },
  {
    id: 'feature-002',
    title: '《疯狂试爱2》角色特辑：演员如何走进人物内心',
    type: 'feature',
    category: 'feature',
    subcategory: '角色特辑',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20actor%20portrait%20in%20profile%20with%20warm%20orange%20rim%20light%20and%20deep%20blue%20background%2C%20thoughtful%20expression%2C%20dramatic%20studio%20lighting%2C%20moody%20atmospheric%20tone%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c09&orientation=landscape',
    date: '2026-09-16',
    summary:
      '角色特辑走进演员的准备过程，从写人物小传、体验生活到反复围读剧本，完整呈现角色如何被一点点建立起来。',
    views: 16780,
    tags: ['角色特辑', '演员', '创作过程'],
    cast: ['林知夏', '沈砚舟', '苏晚', '周予安'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '特辑以四位主演的视角，讲述他们如何理解人物动机，并在表演中让角色显得真实可信。',
    fullText:
      '《疯狂试爱2》的角色之所以让人记得住，离不开演员在镜头之外做的大量功课。\n\n据透露，几位主演在开拍前都完成了完整的人物小传，把角色在剧本之外的经历补齐，包括他们的家庭背景、职业习惯甚至说话节奏。\n\n为了贴近角色状态，一位主演还特意去体验了角色的日常通勤路线，观察真实环境里的人们如何表达情绪，这些细节后来都悄悄融进了表演中。\n\n围读剧本也是重要环节。整个团队会逐句讨论台词的潜台词，确保每一句话背后都有明确的情绪依据，而不是简单地把台词念出来。\n\n正是这些看不见的准备，让角色在屏幕前拥有了令人信服的生命力。',
  },
  {
    id: 'feature-003',
    title: '《疯狂试爱2》拍摄纪实：城市夜景下的浪漫光影',
    type: 'feature',
    category: 'feature',
    subcategory: '拍摄纪实',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20wet%20city%20street%20at%20night%20reflecting%20warm%20orange%20signage%20against%20deep%20blue%20tones%2C%20glowing%20shallow%20depth%20of%20field%2C%20romantic%20urban%20night%20mood%2C%20moody%20atmospheric%20lighting%2C%20dark%20simple%20background%20with%20negative%20space%2C%20high%20detail&width=800&height=450&seq=fsa2-c10&orientation=landscape',
    date: '2026-09-12',
    summary:
      '城市夜景是《疯狂试爱2》最重要的视觉语言之一。拍摄纪实带你了解团队如何用光影，营造出属于作品的浪漫气质。',
    views: 12940,
    tags: ['拍摄纪实', '光影', '视觉'],
    cast: ['林知夏', '沈砚舟'],
    director: '陈亦航',
    releaseDate: '2026-07-18',
    synopsis:
      '纪实内容聚焦作品夜戏的拍摄方案，解析团队如何通过灯光与构图呈现都市夜晚的情绪质感。',
    fullText:
      '如果说《疯狂试爱2》有一套自己的视觉语言，那一定离不开城市夜景。作品中大量的夜戏，构成了整部作品的情绪底色。\n\n摄影指导在纪实中透露，团队刻意避免了过于明亮的城市灯光，转而选择更有层次感的暖色调光源，让画面在冷与暖之间形成对比。\n\n构图上也做了很多取舍。为了突出人物的情绪，团队经常使用浅景深，把背景虚化成一片柔和的光斑，让观众的目光自然聚焦在角色身上。\n\n雨后的路面是高频率使用的场景。湿润的地面会反射灯光，让整个画面多了一层流动感，也让夜晚显得不那么孤单。\n\n正是这些看似细小的光影决定，共同成就了作品独特的浪漫质感。',
  },
];